import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { SearchFilterModule } from 'src/app/components/search-filter/search-filter.module';
import { PaginatorModule } from 'src/app/components/paginator/paginator.module';
import { IconsModule } from 'src/app/icons/icons.module';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { InstanceExecuteRvtComponent } from './instance-execute-rvt.component';
import { ConfigurationDetailsModule } from '../configuration-details/configuration-details.module';

@NgModule({
  declarations: [
    InstanceExecuteRvtComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    SearchFilterModule,
    PaginatorModule,
    IconsModule,
    MatRadioModule,
    MatFormFieldModule,
    MatInputModule,
    ConfigurationDetailsModule,
    MatProgressSpinnerModule
  ],
  exports: [
    InstanceExecuteRvtComponent
  ]
})
export class InstanceExecuteRvtModule { }
